export default {
  invoice: "Invoice",
  invoiceSettings: "Invoice Settings",
  defaultTerms: {
    label: "Default Invoice Terms",
    help: "Shown on every new invoice unless overridden. Appears in the PDF and the invoice email.",
    saved: "Default invoice terms saved.",
  },
  contractInvoiceLeadTime: {
    label: "Contract Invoice Lead Time",
    help: "Used by every contract and payment that hasn't set its own lead time, and read fresh each time an invoice date is worked out — so changing it also moves payments on contracts you've already signed but haven't invoiced yet. Set it to 0 to issue invoices on the day payment is due, leaving clients no time to pay ahead of the deadline.",
    fieldLabel: "Send contract invoices this many days before payment is due",
    fieldHelper: "Default 7. Range 0–365.",
    rangeError: "Enter a whole number of days between 0 and 365.",
    requiredError: "Contract invoice lead time is required.",
    saved: "Contract invoice lead time updated successfully",
    serverError:
      "Sorry, this setting could not be saved due to an error on our end. Please try again later.",
  },
};
